/**
 * WHAT THE FATE - 3D Chrome Coin Engine for Shopify Liquid Theme
 * High-definition WebGL metallic minted token with realistic physics & environment reflections
 */

let _chromeRenderer = null;
let _chromeAnimId = null;

function initChromeCoin() {
  const container = document.getElementById('ChromeCoinContainer');
  const canvas = document.getElementById('ChromeCoinCanvas');
  if (!container || !canvas) return;

  // If Three.js isn't ready yet, retry in 80ms (up to 25 times)
  if (typeof THREE === 'undefined') {
    if (!window._threeRetryCount) window._threeRetryCount = 0;
    if (window._threeRetryCount < 25) {
      window._threeRetryCount++;
      setTimeout(initChromeCoin, 80);
    }
    return;
  }

  // Clean up any existing animation/renderer before re-initializing
  if (_chromeAnimId) {
    cancelAnimationFrame(_chromeAnimId);
    _chromeAnimId = null;
  }
  if (_chromeRenderer) {
    try {
      _chromeRenderer.dispose();
    } catch (e) {}
    _chromeRenderer = null;
  }

  const isMobile = window.innerWidth < 768;
  const defaultDeskWidth = 480;
  const defaultDeskHeight = 480;
  const defaultMobWidth = 320;
  const defaultMobHeight = 320;

  const coinWidth = isMobile
    ? parseFloat(container.dataset.mobileCoinWidth || defaultMobWidth)
    : parseFloat(container.dataset.coinWidth || defaultDeskWidth);
  const coinHeight = isMobile
    ? parseFloat(container.dataset.mobileCoinHeight || defaultMobHeight)
    : parseFloat(container.dataset.coinHeight || defaultDeskHeight);
  const metallic = parseFloat(container.dataset.metallic || 96) / 100;
  const roughness = parseFloat(container.dataset.roughness || 14) / 100;
  const reflection = parseFloat(container.dataset.reflection || 95) / 100;
  const bevel = parseFloat(container.dataset.bevel || 45);
  const depth = parseFloat(container.dataset.depth || 40);
  const customPng = container.dataset.customPng;

  // Sizing container: Large and majestic
  const containerW = isMobile ? Math.min(380, coinWidth * 1.15) : coinWidth * 1.15;
  const containerH = isMobile ? Math.min(380, coinHeight * 1.15) : coinHeight * 1.15;
  container.style.width = `${containerW}px`;
  container.style.height = `${containerH}px`;

  // Scene, Camera, Renderer
  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(38, containerW / containerH, 0.1, 1000);
  camera.position.z = 5.2;

  let renderer;
  try {
    renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true, powerPreference: 'high-performance' });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.setSize(containerW, containerH);
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.5;
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    _chromeRenderer = renderer;
  } catch (e) {
    console.warn('Three.js WebGL init error:', e);
    return;
  }

  // Create High-Contrast Studio Environment Map
  const envCanvas = document.createElement('canvas');
  envCanvas.width = 1024;
  envCanvas.height = 512;
  const eCtx = envCanvas.getContext('2d');
  const eGrad = eCtx.createLinearGradient(0, 0, 0, 512);
  eGrad.addColorStop(0, '#101216');
  eGrad.addColorStop(0.35, '#282d36');
  eGrad.addColorStop(0.5, '#6a7280');
  eGrad.addColorStop(0.65, '#282d36');
  eGrad.addColorStop(1, '#090a0d');
  eCtx.fillStyle = eGrad;
  eCtx.fillRect(0, 0, 1024, 512);

  // Softbox light strip
  eCtx.fillStyle = '#ffffff';
  eCtx.fillRect(100, 20, 824, 90);
  // Lateral rim lights
  eCtx.fillStyle = 'rgba(250, 252, 255, 0.9)';
  eCtx.fillRect(40, 160, 240, 160);
  eCtx.fillRect(744, 160, 240, 160);
  // Specular horizon line
  eCtx.fillStyle = 'rgba(255, 255, 255, 0.7)';
  eCtx.fillRect(0, 250, 1024, 14);

  const envTexture = new THREE.CanvasTexture(envCanvas);
  envTexture.mapping = THREE.EquirectangularReflectionMapping;
  scene.environment = envTexture;

  // 4-Point Studio Lighting
  const ambientLight = new THREE.AmbientLight(0xffffff, 0.65);
  scene.add(ambientLight);

  const keyLight = new THREE.DirectionalLight(0xffffff, 3.4);
  keyLight.position.set(4, 5, 6);
  scene.add(keyLight);

  const rimLight = new THREE.DirectionalLight(0xedf2ff, 3.0);
  rimLight.position.set(-6, -2, -4);
  scene.add(rimLight);

  const topLight = new THREE.DirectionalLight(0xffffff, 2.6);
  topLight.position.set(0, 6, 2);
  scene.add(topLight);

  const bottomBounce = new THREE.DirectionalLight(0x8a95a4, 1.6);
  bottomBounce.position.set(0, -5, 3);
  scene.add(bottomBounce);

  // Group
  const objectGroup = new THREE.Group();
  scene.add(objectGroup);

  // High-Resolution Procedural Coin Texture (Front Face)
  const faceCanvas = document.createElement('canvas');
  faceCanvas.width = 1024;
  faceCanvas.height = 1024;
  const ctx = faceCanvas.getContext('2d');

  const baseGrad = ctx.createRadialGradient(512, 512, 40, 512, 512, 510);
  baseGrad.addColorStop(0, '#e2e5e9');
  baseGrad.addColorStop(0.4, '#b4b8be');
  baseGrad.addColorStop(0.7, '#8f9399');
  baseGrad.addColorStop(0.92, '#f0f3f6');
  baseGrad.addColorStop(1, '#505358');
  ctx.fillStyle = baseGrad;
  ctx.fillRect(0, 0, 1024, 1024);

  // Anisotropic circular brushing
  for (let i = 0; i < 600; i++) {
    const angle = Math.random() * Math.PI * 2;
    const r = 160 + Math.random() * 330;
    ctx.strokeStyle = Math.random() > 0.5 ? 'rgba(255,255,255,0.14)' : 'rgba(0,0,0,0.12)';
    ctx.lineWidth = 1 + Math.random() * 2;
    ctx.beginPath();
    ctx.arc(512, 512, r, angle, angle + 0.45);
    ctx.stroke();
  }

  // Broad outer rim
  ctx.lineWidth = 42;
  ctx.strokeStyle = '#ffffff';
  ctx.beginPath();
  ctx.arc(512, 512, 474, 0, Math.PI * 2);
  ctx.stroke();

  // Outer groove
  ctx.lineWidth = 8;
  ctx.strokeStyle = '#2b2e33';
  ctx.beginPath();
  ctx.arc(512, 512, 450, 0, Math.PI * 2);
  ctx.stroke();

  // Beaded circular border
  const beadCount = 72;
  for (let i = 0; i < beadCount; i++) {
    const th = (i / beadCount) * Math.PI * 2;
    const bx = 512 + Math.cos(th) * 424;
    const by = 512 + Math.sin(th) * 424;
    ctx.fillStyle = '#ffffff';
    ctx.beginPath();
    ctx.arc(bx, by, 7.5, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = '#1c1e22';
    ctx.beginPath();
    ctx.arc(bx + 1.8, by + 1.8, 4.5, 0, Math.PI * 2);
    ctx.fill();
  }

  // Circular Arch Text
  ctx.save();
  ctx.font = '900 44px sans-serif';
  ctx.fillStyle = '#ffffff';
  ctx.textAlign = 'center';
  ctx.shadowColor = 'rgba(0,0,0,0.85)';
  ctx.shadowBlur = 12;
  ctx.shadowOffsetX = 3;
  ctx.shadowOffsetY = 4;

  const topText = "WHAT THE FATE";
  const rad = 352;
  for (let i = 0; i < topText.length; i++) {
    const charAngle = -Math.PI / 2 + (i - (topText.length - 1) / 2) * 0.16;
    ctx.save();
    ctx.translate(512 + Math.cos(charAngle) * rad, 512 + Math.sin(charAngle) * rad);
    ctx.rotate(charAngle + Math.PI / 2);
    ctx.fillText(topText[i], 0, 0);
    ctx.restore();
  }

  const bottomText = "★ 2026 • GEN-Z LUXURY ★";
  for (let i = 0; i < bottomText.length; i++) {
    const charAngle = Math.PI / 2 + (i - (bottomText.length - 1) / 2) * 0.125;
    ctx.save();
    ctx.translate(512 + Math.cos(charAngle) * rad, 512 + Math.sin(charAngle) * rad);
    ctx.rotate(charAngle - Math.PI / 2);
    ctx.fillText(bottomText[i], 0, 0);
    ctx.restore();
  }
  ctx.restore();

  // Center Inner Medallion Border
  ctx.lineWidth = 14;
  ctx.strokeStyle = '#f5f7fa';
  ctx.beginPath();
  ctx.arc(512, 512, 276, 0, Math.PI * 2);
  ctx.stroke();

  // Recessed center circular field
  const centerDiskGrad = ctx.createRadialGradient(512, 512, 20, 512, 512, 264);
  centerDiskGrad.addColorStop(0, '#afb4ba');
  centerDiskGrad.addColorStop(0.7, '#888d94');
  centerDiskGrad.addColorStop(1, '#4c4f55');
  ctx.fillStyle = centerDiskGrad;
  ctx.beginPath();
  ctx.arc(512, 512, 262, 0, Math.PI * 2);
  ctx.fill();

  // Massive Center Monogram "WTF"
  ctx.save();
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.font = '900 185px sans-serif';
  ctx.fillStyle = '#0a0b0d';
  ctx.fillText('WTF', 518, 502);
  ctx.fillStyle = '#ffffff';
  ctx.fillText('WTF', 506, 492);

  ctx.font = '700 24px sans-serif';
  ctx.letterSpacing = '10px';
  ctx.fillStyle = '#e8eaed';
  ctx.fillText('EST. 2024', 512, 592);
  ctx.restore();

  // Bump map for 3D relief
  const bumpCanvas = document.createElement('canvas');
  bumpCanvas.width = 1024;
  bumpCanvas.height = 1024;
  const bCtx = bumpCanvas.getContext('2d');
  bCtx.fillStyle = '#808080';

  bCtx.lineWidth = 42;
  bCtx.strokeStyle = '#ffffff';
  bCtx.beginPath();
  bCtx.arc(512, 512, 474, 0, Math.PI * 2);
  bCtx.stroke();

  bCtx.lineWidth = 14;
  bCtx.strokeStyle = '#ffffff';
  bCtx.beginPath();
  bCtx.arc(512, 512, 276, 0, Math.PI * 2);
  bCtx.stroke();

  bCtx.font = '900 185px sans-serif';
  bCtx.fillStyle = '#ffffff';
  bCtx.textAlign = 'center';
  bCtx.textBaseline = 'middle';
  bCtx.fillText('WTF', 510, 496);

  // Reverse Back Texture
  const backCanvas = document.createElement('canvas');
  backCanvas.width = 1024;
  backCanvas.height = 1024;
  const kCtx = backCanvas.getContext('2d');
  kCtx.fillStyle = baseGrad;
  kCtx.fillRect(0, 0, 1024, 1024);

  kCtx.lineWidth = 42;
  kCtx.strokeStyle = '#ffffff';
  kCtx.beginPath();
  kCtx.arc(512, 512, 474, 0, Math.PI * 2);
  kCtx.stroke();

  // Rim serration (Milled Knurled Edge)
  const rimCanvas = document.createElement('canvas');
  rimCanvas.width = 1024;
  rimCanvas.height = 128;
  const rCtx = rimCanvas.getContext('2d');
  rCtx.fillStyle = '#777777';
  rCtx.fillRect(0, 0, 1024, 128);
  for (let x = 0; x < 1024; x += 4) {
    rCtx.fillStyle = x % 8 === 0 ? '#ffffff' : '#222222';
    rCtx.fillRect(x, 0, 4, 128);
  }

  const faceTexture = new THREE.CanvasTexture(faceCanvas);
  faceTexture.colorSpace = THREE.SRGBColorSpace;
  const backTexture = new THREE.CanvasTexture(backCanvas);
  backTexture.colorSpace = THREE.SRGBColorSpace;
  const bumpTexture = new THREE.CanvasTexture(bumpCanvas);
  const rimBumpTexture = new THREE.CanvasTexture(rimCanvas);
  rimBumpTexture.wrapS = THREE.RepeatWrapping;
  rimBumpTexture.repeat.set(24, 1);

  // Chrome Physical Material
  const chromeMat = new THREE.MeshPhysicalMaterial({
    color: new THREE.Color(0xe0e4e9),
    metalness: metallic,
    roughness: roughness,
    envMapIntensity: reflection * 3.4,
    clearcoat: 0.98,
    clearcoatRoughness: 0.06,
    reflectivity: 0.99,
  });

  // World Sizing
  const scaleMultiplier = coinWidth / (isMobile ? defaultMobWidth : defaultDeskWidth);
  const worldRadius = 1.92 * scaleMultiplier;
  const worldDepth = ((depth / 25) * 0.32) * scaleMultiplier;

  const geom = new THREE.CylinderGeometry(worldRadius, worldRadius, worldDepth, 128, 4);

  const rimMaterial = chromeMat.clone();
  rimMaterial.bumpMap = rimBumpTexture;
  rimMaterial.bumpScale = 0.14;

  const faceMaterial = chromeMat.clone();
  faceMaterial.map = faceTexture;
  faceMaterial.bumpMap = bumpTexture;
  faceMaterial.bumpScale = (bevel / 100) * 0.20;

  const backMaterial = chromeMat.clone();
  backMaterial.map = backTexture;
  backMaterial.bumpMap = bumpTexture;
  backMaterial.bumpScale = (bevel / 100) * 0.20;

  const coinMesh = new THREE.Mesh(geom, [rimMaterial, faceMaterial, backMaterial]);
  coinMesh.rotation.x = Math.PI / 2;
  objectGroup.add(coinMesh);

  // 3D Chamfer Bevel Ring on Front Face (Torus specular glint)
  const frontBevelGeom = new THREE.TorusGeometry(worldRadius - 0.05, 0.065 * scaleMultiplier, 16, 128);
  const bevelMat = chromeMat.clone();
  bevelMat.roughness = Math.max(0.04, roughness * 0.6);
  const frontBevelMesh = new THREE.Mesh(frontBevelGeom, bevelMat);
  frontBevelMesh.position.z = worldDepth / 2;
  objectGroup.add(frontBevelMesh);

  const backBevelMesh = new THREE.Mesh(frontBevelGeom, bevelMat);
  backBevelMesh.position.z = -worldDepth / 2;
  objectGroup.add(backBevelMesh);

  // Initial tilt: ~20° so the front face and top thickness are clearly visible
  let isDragging = false;
  let prevPos = { x: 0, y: 0 };
  let velocity = { x: 0, y: 0 };
  let targetRot = { x: 0.32, y: 0.05 };

  const onPointerDown = (e) => {
    isDragging = true;
    prevPos = { x: e.clientX, y: e.clientY };
    velocity = { x: 0, y: 0 };
  };

  const onPointerMove = (e) => {
    if (!isDragging) return;
    const dx = e.clientX - prevPos.x;
    const dy = e.clientY - prevPos.y;
    velocity = { x: dy * 0.01, y: dx * 0.01 };
    targetRot.y += dx * 0.01;
    targetRot.x += dy * 0.01;
    prevPos = { x: e.clientX, y: e.clientY };
  };

  const onPointerUp = () => { isDragging = false; };

  canvas.addEventListener('pointerdown', onPointerDown);
  window.addEventListener('pointermove', onPointerMove);
  window.addEventListener('pointerup', onPointerUp);

  let clock = new THREE.Clock();
  const animate = () => {
    _chromeAnimId = requestAnimationFrame(animate);
    const delta = clock.getElapsedTime();

    if (!isDragging) {
      velocity.x *= 0.92;
      velocity.y *= 0.92;
      targetRot.x += velocity.x;
      targetRot.y += velocity.y;

      // Subtle, luxurious 3D floating movement (front face remains proudly visible)
      const idleYaw = Math.sin(delta * 0.9) * 0.16;
      const idlePitch = 0.32 + Math.sin(delta * 1.2) * 0.06;
      objectGroup.position.y = Math.sin(delta * 1.5) * 0.08;

      targetRot.x = THREE.MathUtils.lerp(targetRot.x, idlePitch, 0.04);
      if (Math.abs(velocity.y) < 0.002) {
        targetRot.y = THREE.MathUtils.lerp(targetRot.y, idleYaw, 0.03);
      }
    }

    objectGroup.rotation.x = THREE.MathUtils.lerp(objectGroup.rotation.x, targetRot.x, 0.1);
    objectGroup.rotation.y = THREE.MathUtils.lerp(objectGroup.rotation.y, targetRot.y, 0.1);

    renderer.render(scene, camera);
  };
  animate();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initChromeCoin);
} else {
  initChromeCoin();
}

document.addEventListener('shopify:section:load', (e) => {
  if (e.target && e.target.querySelector('#ChromeCoinCanvas')) {
    setTimeout(initChromeCoin, 60);
  }
});

window.addEventListener('resize', () => {
  clearTimeout(window._coinResizeTimer);
  window._coinResizeTimer = setTimeout(initChromeCoin, 150);
});
